import { createRouter, createWebHistory } from 'vue-router';
import { useAuthStore, useApiStore } from '@/stores';
import { routes } from '@/router/routes';

export const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    return savedPosition || { top: 0, left: 0 };
  },
});

router.beforeEach(async (to) => {
  document.title = `${to.meta.title} | Areeb Admin`;

  const apiStore = useApiStore();
  const authStore = useAuthStore();

  const publicPages = ['/login', '/register', '/verify'];
  const isPublicRoute = publicPages.includes(to.path) || to.meta.public === true;

  // Restore admin session only when an authenticated route is being visited.
  // On public routes (notably /driver/:accessToken) a stale admin token in
  // localStorage would otherwise trigger AuthApi.authenticate() → fail →
  // logout() → router.push('/login'), yanking the driver away from the page.
  if (!isPublicRoute) {
    apiStore.initializeFromStorage();
  }

  const authRequired = !isPublicRoute;
  if (authRequired && !apiStore.currentUser) {
    authStore.returnUrl = to.fullPath;
    return '/login';
  }
});
